import React from "react";
import { ArrowDown, ArrowUp } from "lucide-react";
import classNames from "classnames";
import styles from "./ColumnSortUI.module.scss";

export interface ColumnSortUIProps {
  sortActive?: boolean;
  sortDirection?: "asc" | "desc";
  onSortChange?: (direction: "asc" | "desc" | undefined) => void;
  sortAscLabel?: string;
  sortDescLabel?: string;
}

export function ColumnSortUI({
  sortActive = false,
  sortDirection = "desc",
  onSortChange,
  sortAscLabel = "Ascending",
  sortDescLabel = "Descending",
}: ColumnSortUIProps) {
  return (
    <div className={styles.sortContainer}>
      <div className={styles.sortHeader}>
        <span className={styles.sortTitle}>SORT</span>
        {sortActive && (
          <button
            type="button"
            className={styles.sortClearBtn}
            onClick={() => onSortChange?.(undefined)}
          >
            Clear
          </button>
        )}
      </div>
      <div className={styles.sortGrid}>
        <button
          type="button"
          onClick={() => onSortChange?.("asc")}
          className={classNames(
            styles.sortBtn,
            sortActive && sortDirection === "asc" && styles.sortBtnActive
          )}
        >
          <ArrowUp size={13} />
          {sortAscLabel}
        </button>
        <button
          type="button"
          onClick={() => onSortChange?.("desc")}
          className={classNames(
            styles.sortBtn,
            sortActive && sortDirection === "desc" && styles.sortBtnActive
          )}
        >
          <ArrowDown size={13} />
          {sortDescLabel}
        </button>
      </div>
    </div>
  );
}
